import React from "react";
import PropTypes from "prop-types";
import { Link, IndexLink } from "react-router";
import { connect } from "react-redux";
import { prependRoot } from "../../util/prependRoot.js";


class RelativeLink extends React.Component {
	constructor(props, context) {
		super(props, context);
	}

	render() {
		const {
			siteRoot,
			to,
			title,
			className,
			newTab,
			isRootLink
		} = this.props;

		const target = newTab ? "_blank" : "";
		const relativeTo = prependRoot(to, siteRoot);

		return (
			isRootLink ?
				<IndexLink
					to={relativeTo} target={newTab} title={title} activeClassName="active"
					className={className}>{this.props.children}
				</IndexLink> :
				<Link
					to={relativeTo} target={newTab} title={title} activeClassName="active"
					className={className}>{this.props.children}
				</Link>
		);
	}
}

RelativeLink.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.string
	]),
	siteRoot: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
	title: PropTypes.string,
	className: PropTypes.string,
	newTab: PropTypes.bool,
	isRootLink: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
	return {
		siteRoot: state.settings.siteRoot
	};
}

export default connect(mapStateToProps)(RelativeLink);
